import React, { useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import logo from "../../assets/onnize.png"
import { toast } from 'react-toastify'
import { api } from '../../app/Api/ApiSlice'

const ResetPassword = () => {
    const [password, setPassword] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    const [isLoading, setIsLoading] = useState(false)

    const navigate = useNavigate()
    const location = useLocation()

    const params = new URLSearchParams(location.search)
    const token = params.get("token")
    const email = params.get("email")

    const handleSubmit = async (e) => {
        e.preventDefault()

        setErrorMessage("")

        if (!password) {
            return setErrorMessage("Password is required")
        }

        if (password.length < 6) {
            return setErrorMessage(
                "Password must be at least 6 characters"
            )
        }

        try {
            setIsLoading(true)

            const res = await api.post(
                `/account/reset-password?token=${token}&email=${email}`,
                { password }
            )

            toast.success(
                res.data.message || "Password reset successful"
            )

            setTimeout(() => {
                navigate("/login")
            }, 1500)

        } catch (error) {
            console.log(error)

            setErrorMessage(
                error.response?.data?.message ||
                "Reset failed or token expired"
            )
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className='reset-password userform'>
            <div className="onnize-logo">
                <img src={logo} alt="onnize" />
            </div>

            <form onSubmit={handleSubmit}>
                <h1 className="form-header">
                    New Password
                </h1>

                {errorMessage && (
                    <div className="error-message">
                        <p>{errorMessage}</p>
                    </div>
                )}

                <div className="form-input">
                    <label>Password</label>

                    <input
                        type="password"
                        placeholder="Enter new password"
                        value={password}
                        onChange={(e)=>setPassword(e.target.value)}
                    />
                </div>

                <div className="form-btn">
                    <button
                        type="submit"
                        disabled={isLoading}
                    >
                        {isLoading ? "Saving..." : "Save"}
                    </button>
                </div>
            </form>

            <div className="change-form">
                <p>Don't have an account?</p>
                <Link to="/signup">
                    Signup
                </Link>
            </div>
        </div>
    )
}

export default ResetPassword